var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"mainApp"}},[_c('catergory-nav-mobile'),(_vm.$route.path ==='/' && _vm.screenWidth < 991)?_c('mobile-header-sticky'):_vm._e(),((!_vm.$route.path.includes('vendor') &&
                           !_vm.$route.path.includes('agent') &&
                           !_vm.$route.path.includes('tenant') &&
                          ((_vm.screenWidth < 991 && _vm.$route.path ==='/')||
                          (_vm.screenWidth > 991)) &&
                          (!_vm.$route.path.includes('login') &&
                          !_vm.$route.path.includes('signup')&&
                          !_vm.$route.path.includes('reset-password')&&
                          !_vm.$route.path.includes('forgotPassword'))))?_c('header-nav-tab'):_vm._e(),(_vm.$route.path.includes('vendor') ||
                                _vm.$route.path.includes('agent')||
                                _vm.$route.path.includes('tenant')||
                                _vm.$route.path.includes('login') ||
                                _vm.$route.path.includes('signup') ||
                                _vm.$route.path.includes('reset-password') ||
                                _vm.$route.path.includes('forgotPassword'))?_c('header-nav-tab-three'):_vm._e(),(!_vm.$route.path.includes('vendor')&&
                              !_vm.$route.path.includes('agent')&&
                              !_vm.$route.path.includes('tenant')&&
                              !_vm.$route.path.includes('login') &&
                              !_vm.$route.path.includes('signup')&&
                              !_vm.$route.path.includes('reset-password')&&
                              !_vm.$route.path.includes('forgotPassword')&&
                              _vm.screenWidth < 991 &&
                              _vm.$route.path !=='/')?_c('mobile-header-back'):_vm._e(),(!_vm.$route.path.includes('vendor') &&
                            !_vm.$route.path.includes('agent') &&
                            !_vm.$route.path.includes('tenant') &&
                            !_vm.$route.path.includes('login') &&
                            !_vm.$route.path.includes('signup')&&
                            !_vm.$route.path.includes('reset-password')&&
                            !_vm.$route.path.includes('forgotPassword'))?_c('category-nav-bar'):_vm._e(),_c('router-view',{key:_vm.$route.path}),((_vm.screenWidth < 991 &&
                        _vm.$route.path ==='/')||
                        (_vm.screenWidth > 991))?_c('site-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }